"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@chakra-ui/react");
const react_2 = __importDefault(require("react"));
/**
 * Fixed width container for lists of tasks
 */
const VerticalList = ({ children, ...rest }) => {
    const { colorMode } = react_1.useColorMode();
    const colorProps = colorMode === "light" ? { bgColor: "gray.100" } : { bgColor: "gray.700" };
    return (react_2.default.createElement(react_1.Box, { h: "100%", display: "inline-block" },
        react_2.default.createElement(react_1.Box, Object.assign({ rounded: "md", minWidth: "17rem", boxShadow: "lg" }, colorProps, { maxH: "100%", display: "flex", margin: "0 .25rem", justify: "space-between", padding: ".375rem .25rem", flexDir: "column" }, rest), children)));
};
exports.default = VerticalList;
//# sourceMappingURL=VerticalList.js.map